import { Injectable } from '@angular/core';
import {MediaObserver} from "@angular/flex-layout";
import {map} from "rxjs/operators";
import {Observable, ReplaySubject} from "rxjs";

@Injectable()
export class EDSngMediaService {
  _nCols: ReplaySubject<number> = new ReplaySubject(1);
  _sizeAlias: ReplaySubject<string> = new ReplaySubject(1);

  get nCols(): Observable<number> {
    return this._nCols.asObservable();
  }
  get sizeAlias(): Observable<string> {
    return this._sizeAlias.asObservable();
  }

  constructor(private media: MediaObserver) {


    media.asObservable().pipe(
        map(x => document.getElementById('mygrid_area')),
        map((x) => x ? x.clientWidth / 270 : 1))
      .subscribe(
        x => this._nCols.next(x),
        (err) => this._nCols.error(err),
       () => this._nCols.complete()
    );

    media.media$.pipe(map(({mqAlias}) => mqAlias))
      .subscribe(
      x => this._sizeAlias.next(x),
      (err) => this._sizeAlias.error(err),
      () => this._sizeAlias.complete()
    );
    setTimeout(() => {
      const myGridArea = document.getElementById('mygrid_area');
      this._nCols.next(myGridArea ? myGridArea.clientWidth / 270 : 1);
    }, 500);

  }

}
